import { useState, useEffect } from "react";
import { GroupMember } from "../types/gigya";
import { GigyaGroupModels } from "../types/gigya.schema";

export const useGetGroupMemberInfo = (groupId: string | undefined) => {
  const [loadingGroupMemberInfo, setLoadingGroupMemberInfo] = useState(true);
  const [groupMemberInfoError, setGroupMemberInfoError] = useState(false);
  const [groupMemberInfo, setGroupMemberInfo] = useState<GroupMember>();
  const [newGroupMemberInfoID, setNewGroupMemberInfoID] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (groupId) {
      window.gigya.accounts.groups.getGroupMemberInfo({
        model: GigyaGroupModels.ClinicModel,
        groupId: groupId,
        callback: (response) => {
          if (response.errorCode) {
            console.log("Error Details: ", response.errorDetails);
            setLoadingGroupMemberInfo(true);
            setGroupMemberInfoError(true);
          } else {
            setGroupMemberInfo(response.result);
            setLoadingGroupMemberInfo(false);
            setGroupMemberInfoError(false);
          }
        },
      });
    }

    return () => {
      setGroupMemberInfo(undefined);
    };
  }, [groupId]);

  useEffect(() => {
    if (newGroupMemberInfoID) {
      window.gigya.accounts.groups.getGroupMemberInfo({
        model: GigyaGroupModels.ClinicModel,
        groupId: newGroupMemberInfoID,
        callback: (response) => {
          if (response.result) {
            setGroupMemberInfo(response.result);
          }
        },
      });
    }

    return () => {
      setNewGroupMemberInfoID(undefined);
    };
  }, [newGroupMemberInfoID]);

  return {
    loadingGroupMemberInfo,
    groupMemberInfoError,
    groupMemberInfo,
    setGroupMemberInfo,
    setNewGroupMemberInfoID,
  };
};
